import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';

import { useGetWorkdaySupplierDetails } from '@/modules/workingDayReconciliation/apiHooks';
import {
  checkConflict,
  WorkdaySupplierDetailsTableColumns,
} from '@/modules/workingDayReconciliation/components/CrewLevel/WorkdaySupplierDetailsTable/logic';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { Loading, Table } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';

interface IWorkdaySupplierDetailsTable {
  date: string;
  supplierId: number;
}

export default function WorkdaySupplierDetailsTable({
  date,
  supplierId,
}: IWorkdaySupplierDetailsTable): ReactElement {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data, isLoading } = useGetWorkdaySupplierDetails({
    date,
    entityId: selectedAsset?.id,
    supplierId,
  });

  // if loading
  if (isLoading) {
    return <Loading />;
  }

  // if no data found
  if (!data && !isLoading) {
    return (
      <div className=' w-full rounded-lg bg-white px-0 py-16 text-center text-20 font-semi-bold'>
        {t('no-jobs')}
      </div>
    );
  }

  return (
    <div className=''>
      <Table<IReconciliation.IGetWorkdaySupplierDetails>
        columnsDividerIndexes={[4, 6, 10, 14, 17]}
        stickyLastCloumn
        tableWrapperClassName='max-h-520 text-center'
        rowContainerClassNameFu={(row) =>
          checkConflict(row) ? 'bg-error-100' : ''
        }
        // rowContainerClassName='cursor-pointer'
        selection={false}
        columns={WorkdaySupplierDetailsTableColumns(
          t,
          selectedAsset?.currency || ''
        )}
        // filter data in case wasred time and total hours 0
        data={
          data.filter(
            (item) =>
              !(item.category === 'WASTED-TIME' && item.totalTimeSpent === 0)
          ) || []
        }
        pagination={false}
      />
    </div>
  );
}
